import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SideMenuComponent } from './component/side-menu/side-menu.component';
import { HeaderComponent } from './component/header/header.component';
import { ToastModule } from 'primeng/toast';
import { LoadingOverlayComponent } from '@shared/components/loading-overlay/loading-overlay.component';
import { LayoutService } from './service/layout.service';

@Component({
    selector: 'app-layout',
    standalone: true,
    imports: [CommonModule, RouterModule, SideMenuComponent, HeaderComponent, ToastModule, LoadingOverlayComponent],
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LayoutComponent {
    private layoutService = inject(LayoutService);
    sidebarCollapsed = this.layoutService.sidebarCollapsed;
}
